import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import WebFont from 'webfontloader';
import App from './App';

WebFont.load({
	google: {
		families: ['Open Sans:400,500,600,700', 'Oswald:400,500,600,700'],
	},
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);
